import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { API } from "@/lib/api";

export const NewsletterSignup = ({ testId = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success(res.data.detail === "already subscribed" ? "You're already subscribed" : "Subscribed! See you Monday morning.");
      setDone(true);
      setEmail("");
    } catch {
      toast.error("Please enter a valid email address");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid={`${testId}-success`} className="flex items-center gap-3 text-emerald-300 text-sm">
        <MailCheck size={18} className="text-gold" /> You're subscribed — the next digest arrives Monday morning.
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${testId}-form`} className="flex flex-col sm:flex-row gap-3 max-w-md">
      <Input
        data-testid={`${testId}-email-input`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className="bg-slate3 border-white/10 rounded-sm flex-1"
      />
      <button
        data-testid={`${testId}-submit-button`}
        type="submit"
        disabled={loading}
        className="bg-gold text-night hover:bg-goldhover transition-colors rounded-sm px-6 py-2.5 text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60 shrink-0"
      >
        {loading && <Loader2 size={14} className="animate-spin" />}
        Subscribe
      </button>
    </form>
  );
};
